import React from 'react';
import { MessageSquare, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import ContactCard from './ContactCard';

const ContactsList = ({
  loading,
  contacts,
  sortedContacts,
  formatDate,
  onOpen,
  onToggleStatus,
  onDelete,
}) => (
  <Card className="table-card">
    <CardHeader>
      <CardTitle>Contact Form Submissions</CardTitle>
    </CardHeader>
    <CardContent>
      {(() => {
        if (loading) {
          return (
            <div className="loading-state">
              <RefreshCw className="animate-spin" size={32} />
              <p>Loading messages...</p>
            </div>
          );
        }
        if (contacts.length === 0) {
          return (
            <div className="empty-state">
              <MessageSquare size={48} />
              <h3>No Messages Yet</h3>
              <p>Contact form submissions will appear here.</p>
            </div>
          );
        }
        return (
          <div className="contacts-list">
            {sortedContacts.map((contact) => (
              <ContactCard
                key={contact.id}
                contact={contact}
                formatDate={formatDate}
                onOpen={onOpen}
                onToggleStatus={onToggleStatus}
                onDelete={onDelete}
              />
            ))}
          </div>
        );
      })()}
    </CardContent>
  </Card>
);

export default ContactsList;
